<template>
  <div class="games-page">
    <div class="page-title">
      <img src="@/assets/icons/pawn_150.png"/>
      <h1>Games</h1>
    </div>
    <div class="page-content">
      <div class="game-tile">
        Coming soon
      </div>
      <div class="game-tile">
        Coming soon
      </div>
      <div class="game-tile">
        Coming soon
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.games-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding-top: 1rem;
}

.page-title {
  img {
    margin-top: 4px;
    width: 36px;
  }
}

.page-content {
  display: grid;
  grid-template-columns: repeat(3, 1fr);  
  column-gap: 1rem;
}

.game-tile {
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px dotted #ccc;
  border-radius: 12px;
  color: #888;
}
</style>

<script lang="ts" setup>
</script>
